const $$splitComponentImporter = () => import('/build/web/src/routes/dingtalk/entry.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/dingtalk/entry')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

// Minimal shape of the dd JSAPI object loaded from the official CDN.
// Mobile DingTalk auto-injects window.dd; PC client does NOT, so we have to
// load the SDK script ourselves either way.
interface DDJsapi {
  runtime?: {
    permission?: {
      requestAuthCode?: (args: {
        corpId: string;
        onSuccess?: (res: {
          code: string;
        }) => void;
        onFail?: (err: unknown) => void;
      }) => Promise<{
        code: string;
      }> | void;
    };
  };
}
declare global {
  interface Window {
    dd?: DDJsapi;
  }
}

// Loads the official DingTalk JSAPI SDK from alicdn (the CDN DingTalk itself
// recommends in their docs). Resolves once window.dd is available, or rejects
// after a timeout.

// Serialize unknown error shapes (Error, plain object, string, …) into
// something a user can actually read. Returns "" if nothing useful is available.

/**
 * Workplace H5 entry. Runs inside DingTalk's container, which auto-injects
 * window.dd. We call dd.runtime.permission.requestAuthCode directly — no
 * npm SDK, no dd.config, no JSAPI signature.
 *
 * Non-DingTalk environments are redirected to /sign-in so the URL never
 * dead-ends (e.g., when copy-pasted into a regular browser).
 */